import { Link } from "react-router-dom";
import { ArrowUpRight, Truck, Warehouse, ShieldCheck, TrendingUp } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Truck, title: "Freight Brokerage", desc: "LTL · FTL · Flatbed · Oversized · CA / US cross-border." },
  { icon: Warehouse, title: "3PL Warehousing", desc: "Storage, cross-dock, pick & pack, inventory management." },
  { icon: ShieldCheck, title: "Managed Transport", desc: "We own carrier ops, compliance & dispatch — end to end." },
  { icon: TrendingUp, title: "Up to 30% Savings", desc: "Lean ops, consolidation, smart carrier negotiation." },
];

export default function ValuePropTeaser() {
  return (
    <section data-testid="value-prop-teaser" className="relative bg-[#0a0a0a] border-t-2 border-[#D9633F] overflow-hidden">
      {/* Massive watermark */}
      <div
        aria-hidden="true"
        className="absolute right-2 sm:right-8 top-1/2 -translate-y-1/2 font-display font-black text-white/[0.03] text-[7rem] sm:text-[12rem] tracking-tighter pointer-events-none select-none leading-none"
      >
        MDLGX
      </div>

      <div className="container-mdgx relative z-10 py-16 sm:py-20 lg:py-24">
        {/* Header band */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end mb-12 lg:mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="block w-8 h-px bg-[#D9633F]" />
              <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#D9633F]">Managed Transportation Services</span>
            </div>
            <h2
              data-testid="vp-teaser-headline"
              className="font-display font-black text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.02]"
            >
              We run your transport.<br />
              You run your <span className="text-[#D9633F] italic">business</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-white/75 leading-relaxed text-base sm:text-lg">
              MIDEMIDE Logistics experts take full ownership of your transportation unit —
              handling carrier relationships, compliance, cost control, and daily operations —
              so your team stays focused on what drives your core business forward.
            </p>
          </div>
        </div>

        {/* 4-up highlight strip */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {HIGHLIGHTS.map((h) => {
            const Icon = h.icon;
            return (
              <div
                key={h.title}
                data-testid={`vp-teaser-${h.title.toLowerCase().split(" ").slice(0, 2).join("-")}`}
                className="bg-[#0a0a0a] p-6 sm:p-7 group hover:bg-[#D9633F]/5 transition-colors"
              >
                <div className="w-11 h-11 border border-[#D9633F]/40 bg-[#D9633F]/10 flex items-center justify-center mb-4 group-hover:bg-[#D9633F] group-hover:border-[#D9633F] transition-colors">
                  <Icon size={18} className="text-[#D9633F] group-hover:text-white transition-colors" />
                </div>
                <div className="font-display font-bold text-white text-lg leading-tight">{h.title}</div>
                <div className="text-white/60 text-sm mt-2 leading-relaxed">{h.desc}</div>
              </div>
            );
          })}
        </div>

        {/* CTA row */}
        <div className="mt-10 lg:mt-12 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
          <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/50">
            [ The 90–180 day promise · Save up to 30% on freight spend ]
          </div>
          <Link
            to="/value-proposition"
            data-testid="vp-teaser-cta"
            className="inline-flex items-center gap-2 self-start sm:self-auto bg-[#D9633F] hover:bg-[#c2542f] text-white px-6 py-3.5 font-display font-bold tracking-wide text-sm transition-colors shadow-[0_8px_24px_rgba(217,99,63,0.35)]"
          >
            See the full value proposition
            <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
